import HttpFactory from '../factory'
import type { Practitioner } from '../types/practitioner/practitioner'

class PractitionersModule extends HttpFactory<any[]> {
  private RESOURCE = '/practitioners'
  private RESOURCE_V2 = '/v2/practitioners'
  private RESOURCE_PRACTITIONER_SUMMARIES = '/practitioner-summaries'

  async getV2(id?: string): Promise<Practitioner | Practitioner[]> {
    if (!id) {
      let arr: any[] = []
      let nextPageUrl = '?pageSize=2000'
      do {
        await this.call<any>('GET', `${this.RESOURCE_V2}/${nextPageUrl}`).then((response) => {
          arr = arr.concat(response.items)
          nextPageUrl = response.nextPageUrl
        })
      } while (nextPageUrl)
      return arr
    } else return await this.call<any>('GET', `${this.RESOURCE_V2}/${id}`)
  }

  save(obj: any) {
    let formatedMobilePhone = ''
    formatedMobilePhone = obj.mobilePhone.split(' ').join('')
    if (formatedMobilePhone.charAt(0) !== '+' && formatedMobilePhone.charAt(0) === '0') {
      formatedMobilePhone = formatedMobilePhone.replace('0', '+33')
    }
    if (obj.rpps) {
      obj.identifier = { type: 'rpps', value: obj.rpps }
    }
    const data: Partial<Practitioner> = {
      firstName: obj.firstName,
      lastName: obj.lastName,
      mobilePhone: formatedMobilePhone,
      gender: obj.gender,
      role: obj.role,
    }
    if (obj.identifier) data.identifier = obj.identifier
    if (obj.id) {
      return this.call<any>('PATCH', `${this.RESOURCE}/${obj.id}?revision=${obj.revision}`, data)
    } else {
      return this.call<any>('POST', `${this.RESOURCE}`, data)
    }
  }

  async saveV2(data: Practitioner): Promise<Practitioner> {
    if (data.id) {
      return this.call<any>('PATCH', `${this.RESOURCE_V2}/${data.id}?revision=${data.revision}`, {
        gender: data.gender,
        firstName: data.firstName,
        lastName: data.lastName,
        profession: data.profession,
        professionSpecialities: data.professionSpecialities,
        ...(Array.isArray(data.identifiers) && data.identifiers.length > 0 && { identifiers: data.identifiers }),
      })
    } else {
      return await this.call<any>('POST', `${this.RESOURCE_V2}`, data)
    }
  }

  async getCareTeamsIds(practitionerId: string): Promise<Practitioner[]> {
    let arr: any = []
    await this.call<any>('GET', `${this.RESOURCE}/${practitionerId}/care-teams`).then((response) => {
      arr = response.map((p: any) => p.id)
    })
    return arr
  }

  async getCareTeamsIdsV2(practitionerId: string): Promise<Practitioner[]> {
    let arr: any = []
    await this.call<any>('GET', `${this.RESOURCE_V2}/${practitionerId}/care-teams`).then((response) => {
      arr = response
    })
    return arr
  }

  async getPractitionerByPatientId(patientId: string): Promise<string[]> {
    let arr: any = []
    await this.call<any>('GET', `${this.RESOURCE_V2}?patientId=${patientId}`).then((response) => {
      arr = response.items
    })
    return arr
  }

  async getPractitionerSummaries(): Promise<any[]> {
    let arr: any = []
    await this.call<any>('GET', `${this.RESOURCE_PRACTITIONER_SUMMARIES}?pageSize=1000`).then((response) => {
      arr = response.items
    })
    return arr
  }
}

export default PractitionersModule
